import { ExportViewAttendanceExcel } from "./ExportViewAttendanceExcel";
import { ExportViewAttendancePdf } from "./ExportViewAttendancePdf";

export const ExportViewAttendance = ({ attendanceData = [] }) => (
    <div className="d-flex flex-wrap gap-2">
        <ExportViewAttendanceExcel attendanceData={attendanceData} />
        <ExportViewAttendancePdf attendanceData={attendanceData} />
    </div>
);
